// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
/**
 * fix-sprint-20260411-0620-followup Finding 4 — the change types whose effect IS
 * a policy binding. Every binding write a change request makes filters on
 * `policy_id: target_policy_id`, so one of these with no target policy would be
 * deployed while touching no binding. The create schema, the service (create,
 * update, deploy) and the create form all read this one list.
 */
export const CHANGE_REQUEST_TYPES_REQUIRING_POLICY = [
    'policy_update',
    'new_binding',
    'remove_binding',
];
/** Does a change request of this type need a target policy? */
export function changeRequestRequiresPolicy(changeType) {
    return CHANGE_REQUEST_TYPES_REQUIRING_POLICY.includes(changeType ?? '');
}
//# sourceMappingURL=consent-properties.js.map